import moment from 'moment-timezone';

/**
 * Format a JSON timestamp to the user-friendly format 'MM/DD/yyyy'
 * If the timestamp can't be formatted, then '<Unknown timestamp: {timestamp}>' is returned
 * @param timestamp - Timestamp to format
 * @returns Formatted date or unknown timestamp message
 */
export const date = (timestamp: string | Date | null): string | null => {
	if (timestamp === null) return null;
	const instance = moment(timestamp);
	return instance.isValid() ? instance.format('yyyy-MM-DD') : `<Unknown timestamp: ${timestamp}>`;
}

/**
 * Converts a UTC timestamp to Central Time and formats it to 'MM/DD/yyyy'
 * If the timestamp can't be formatted, then '<Unknown timestamp: {timestamp}>' is returned
 * @param timestamp - UTC Timestamp
 * @returns Formatted date or unknown timestamp message
 */
export function ctDate(timestamp: string): string {
	const instance = moment.utc(timestamp).tz('America/Chicago');

	return instance.isValid() ? instance.format('yyyy-MM-DD') : `<Unknown timestamp: ${timestamp}>`;
}

export default date;
